<template>
  <div class="AddAllContract">
    <div class="tabWrap">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="基本信息" name="first" class="firstTab">
          <div class="screenPanel">
            <el-form
              ref="ruleForm"
              :model="dialogForm"
              label-width="110px"
              :inline="true"
              :rules="rules"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="合同编号" prop="serialNumber">
                    <el-input
                      v-model="dialogForm.serialNumber"
                      placeholder="编码格式：GLZX-2018-G308（字母大写）"
                      @change="contractTypechange"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="合同名称" prop="name">
                    <el-input v-model="dialogForm.name"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="是否临时" prop="contractType">
                    <el-select
                      v-model="dialogForm.contractType"
                      placeholder="请选择"
                      default-first-option
                      @change="contractTypechange"
                      :disabled="editcontractTypeFlag"
                    >
                      <el-option label="否" value="ADDITIONAL"></el-option>
                      <el-option label="是" value="TEMPORARY"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="合同甲方" prop="partyAId">
                    <!-- <el-input v-model="dialogForm.partyA"></el-input> -->
                    <el-select
                      v-model="dialogForm.partyAId"
                      filterable
                      placeholder="请选择"
                      @change="ContractPartAChange"
                    >
                      <el-option
                        :label="supplier.companyName"
                        :value="supplier.id"
                        v-for="supplier in SupplierList"
                        :key="supplier.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="合同乙方" prop="partyBId">
                    <el-select
                      v-model="dialogForm.partyBId"
                      filterable
                      default-first-option
                      placeholder="请选择"
                      @change="ContractPartBChange"
                    >
                      <el-option
                        :label="supplier.companyName"
                        :value="supplier.id"
                        v-for="supplier in SupplierBList"
                        :key="supplier.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="合同金额" prop="amount">
                    <el-input
                      v-model="dialogForm.amount"
                      @keyup.native="checkAmount(1)"
                      @blur="Fornmat(1)"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="间接费比例" prop="indirectExpPct">
                    <el-input
                      v-model="dialogForm.indirectExpPct"
                      @keyup.native="checkIndirectPct"
                    >
                      <i slot="suffix">%</i>
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="间接费金额">
                    <el-input
                      v-model="dialogForm.indirectExp1"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="暂定金金额" prop="provisionalAmount">
                    <el-input
                      v-model="dialogForm.provisionalAmount"
                      @keyup.native="checkAmount(2)"
                      @blur="Fornmat(2)"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="签订日期">
                    <el-date-picker
                      v-model="dialogForm.signDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="签订地点" prop="signPlace">
                    <el-input v-model="dialogForm.signPlace"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="合同分类" prop="typeKey">
                    <el-select
                      v-model="dialogForm.typeKey"
                      filterable
                      default-first-option
                      placeholder="请选择"
                      @change="ContractClassChange"
                    >
                      <el-option
                        :label="item.value"
                        :value="item.label"
                        v-for="(item, index) in ContractClassList"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="缺陷责任期" prop="liabilityPeriod">
                    <el-input v-model="dialogForm.liabilityPeriod"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="工期" prop="projectTime">
                    <el-input v-model="dialogForm.projectTime"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="付款约定" prop="agreeOn">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      v-model="dialogForm.agreeOn"
                      maxlength="566"
                      size="medium"
                      style="width: 100%; min-width: 566px"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="备注">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      v-model="dialogForm.comments"
                      maxlength="566"
                      size="medium"
                      style="width: 100%; min-width: 566px"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="申请人" prop="applyUserName">
                    <el-input
                      v-model="dialogForm.applyUserName"
                      readonly
                    ></el-input>
                    <!-- <el-input
                      v-model="dialogForm.applyUserName"
                      @click.native="ShowApplyUserDia"
                      readonly
                    ></el-input> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="申请部门">
                    <el-input
                      v-model="dialogForm.applyDeptName"
                      readonly
                    ></el-input>
                    <!-- <el-cascader
                      ref="cascaderAddr"
                      v-model="dialogForm.applyDeptId"
                      :options="subDeptList"
                      :props="defaultProps"
                      @change="handleChange"
                      :placeholder="dialogForm.applyDeptName"
                      @active-item-change="handleChange"
                      change-on-select
                    ></el-cascader> -->
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="editFlag">
                <el-col :span="7">
                  <el-form-item label="单据状态:">{{
                    dialogForm.approveStatusName
                  }}</el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="流水号:">{{
                    dialogForm.flowNo
                  }}</el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="单据日期:">{{
                    dialogForm.createTime
                  }}</el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="工程量清单"
          name="second"
          style="text-align: left"
          class="firstTab1"
          v-if="dialogForm.contractType !== 'TEMPORARY'"
        >
          <EngineerList
            ref="engineerListAll"
            @saveChoiceItems="saveChoiceItems"
            :engineerItems="dialogForm.generalContractProjectDetailsVOs"
          ></EngineerList>
        </el-tab-pane>
        <el-tab-pane
          label="附件"
          name="third"
          style="text-align: left"
          class="firstTab"
        >
          <upLoadFileDialog
            :itemVOs="dialogForm.contractItemVOs"
            @saveUpdateFile="saveUpdateFile"
            :addoredit="editFlag"
          ></upLoadFileDialog>
        </el-tab-pane>
        <el-tab-pane
          label="审批流程"
          name="fourth"
          style="text-align: left; width: 90%"
        >
          <ContractApproveLine
            :addoredit="editFlag"
            :itemId="contractId"
            @saveApproveLine="saveApproveLine"
            :approveType="approveType"
            :approveClass="approveClass"
          ></ContractApproveLine>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bottomBtn">
      <el-button type="primary" @click="saveContractInfo(true)"
        >暂 存</el-button
      >
      <el-button type="primary" @click="saveContractInfo(false)"
        >提 交</el-button
      >
      <el-button type="info" @click="close">取 消</el-button>
    </div>
    <!-- 选择申请人弹窗弹框 -->
    <ApplyUserDialog
      @dialogClose="applyUserDiaVisible = false"
      @SaveApplyUser="saveApplyUser"
      @close="closeDialog"
      :applyUserName="dialogForm.applyUserName"
      :applyUserDiaVisible="applyUserDiaVisible"
    ></ApplyUserDialog>
  </div>
</template>

<script>
import {
  saveContractInfoServices, //保存总包合同基础信息
  updateContractInfoServices, //更新一条总包合同基础信息
  getContractDetailService, //获取一条总包合同信息
  getBasicDataListService, //获取合同分类接口
} from "@/services/allContractServices";
import {
  getValidSupplierAList, //获取有效供应商列表接口
} from "../../../services/supplierMagServices";
import { numFilter, accMul } from "@/utils/filters";
import {
  getOrgIdService, //根据用户id获取组织id
  getsubDeptService, //获取项目部二级项目级联列表
  getDeptListService, //根据组织获取项目部一级数据下拉列表
} from "@/services/sysSettingService";
import { saveApproveFun } from "@/page/approveComponents/approve";
import EngineerList from "../commonCell/EngineerListAll"; //总包合同工程量清单tab页
import ContractApproveLine from "../../approveComponents/NewApproveLine"; //新增审批流程
import ApplyUserDialog from "../commonCell/ApplyUserDialog"; //选择申请人弹窗
import upLoadFileDialog from "@/components/upLoadFileDialog"; //上传附件

export default {
  name: "AddAllContract",
  components: {
    ContractApproveLine, //审批流程
    ApplyUserDialog, //选择申请人组件
    EngineerList, //工程量清单
    upLoadFileDialog, //上传附件
  },
  data() {
    return {
      activeName: "first", //活动tab页
      approveType: "genContract", //审批类型
      approveClass: "GENERAL_CONTRACT", //审批类型
      flag:false,  //是否保存过审批流
      editFlag: false, //false：新建 true：编辑
      typeOptions: [
        { typeName: "日常报修", typeCode: "0" },
        { typeName: "投诉", typeCode: "1" },
      ],
      uploadFileUrl: "", //文件上传路径
      uploadFileName: {
        file: "",
      }, //文件名
      fileList: new FormData(),
      list: [],
      noTypeList: [],
      hasUnvaildType: false,
      unValidTypeNum: 0,
      failList: [],
      SupplierList: [], //供应商列表
      SupplierBList: [], //乙方供应商列表
      RouteParam: {}, //存储路由跳转参数
      contractId: 0, //总包合同ID
      subDeptList: [], //部门列表
      applyUserDiaVisible: false, //选择申请人弹窗
      category: "GENERALCONTRACTTYPE", //合同分类
      ContractClassList: [], //合同分类下拉框数据
      editcontractTypeFlag: false, //是否允许编辑是否临时合同字段
      // fileTableData: [], //上传附件table列表
      dialogForm: {
        id: 0,
        serialNumber: "", // 合同编号
        name: "", //合同名称
        partyA: "", //合同甲方
        partyAId: "", //合同甲方id
        partyB: "", //合同乙方
        partyBId: "", //合同乙方
        projectTime: "", //工期
        provisionalAmount: "", //暂定金金额
        signDate: "", //签订日期
        signPlace: "", //签订地点
        amount: "", //合同金额
        applyDeptId: 0, //申请人部门ID
        applyDeptName: "", //申请人部门名称
        applyUserId: 0, //申请人ID
        applyUserName: "", //申请人姓名
        approveUserId: "", //当前审批人
        comments: "", //备注
        indirectExp: 0, //间接费金额
        indirectExpPct: "", //间接费比例
        approveStatus: "", //单据状态
        agreeOn: "", //付款约定
        liabilityPeriod: "", //缺陷责任期
        typeKey: null, //合同分类KEY
        typeValue: null, //合同分类VALUE
        updateTime: "", //更新时间
        createTime: "",
        isDeleted: 0,
        generalContractProjectDetailsVOs: [], //工程量清单预算列表
        contractItemVOs: [], //附件列表
        contractType: "ADDITIONAL", //是否临时合同
        relatedId: "", //关联ID，跳转用
        relatedSerialNumber: "", //关联编号
        isTempSave: "", //是否暂存标识
      },
      approveParams: {
        approveProcessDtoList: [], //审批流列表
        approveStatusEnum: "UNDERAPPLY", //初始审批状态，目前只支持READY和UNDERAPPLY,可用值:READY,RECALL,UNDERAPLLY,PASS,REJECT,SHOW_SAVE,SHOW_CREATE,SHOW_SUBMIT
        itemId: 0, //审批对象ID
        itemName: "", //审批对象描述
      },
      defaultProps: {
        label: "name",
        value: "id",
        lazy: true,
        lazyLoad(node, resolve) {
          const param = {};
          if (undefined != node.value) {
            param.deptId = node.value;
            getsubDeptService(param).then((res) => {
              if (res.code == 10000000) {
                const nodes = res.data;
                nodes.forEach((item) => {
                  item.leaf = item.isLeaf == 1;
                });
                resolve(nodes);
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        },
      },
      rules: {
        serialNumber: [
          { required: true, message: "请填写合同编码", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "请填写合同名称", trigger: "blur" },
          {
            min: 1,
            max: 60,
            message: "长度在 1 到 60 个字符",
            trigger: "blur",
          },
        ],

        partyAId: [
          { required: true, message: "请选择合同甲方", trigger: "change" },
        ],
        partyBId: [
          { required: true, message: "请选择合同乙方", trigger: "change" },
        ],

        amount: [
          { required: true, message: "请填写合同金额", trigger: "blur" },
          {
            min: 1,
            max: 16,
            message: "请输入16位以内数字",
            trigger: "blur",
          },
        ],
        provisionalAmount: [
          { required: true, message: "请填写暂定金金额", trigger: "blur" },
          {
            min: 1,
            max: 16,
            message: "请输入16位以内数字",
            trigger: "blur",
          },
        ],
        typeKey: [
          { required: true, message: "请选择合同分类", trigger: "change" },
        ],
        signDate: [
          {
            type: "date",
            required: true,
            message: "请填写签订日期",
            trigger: "change",
          },
        ],
        indirectExp: [
          { required: true, message: "请填写间接费金额", trigger: "blur" },
          {
            min: 1,
            max: 16,
            message: "请输入16位以内数字",
            trigger: "blur",
          },
        ],
        liabilityPeriod: [
          { required: true, message: "请填写缺陷责任期", trigger: "blur" },
          {
            min: 1,
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: "blur",
          },
        ],
        signPlace: [
          { required: true, message: "请填写签订地点", trigger: "blur" },
          {
            min: 1,
            max: 60,
            message: "长度在 1 到 60 个字符",
            trigger: "blur",
          },
        ],
        indirectExpPct: [
          { required: true, message: "请填写间接费比例", trigger: "blur" },
        ],
        projectTime: [
          { required: true, message: "工期", trigger: "blur" },
          {
            min: 1,
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: "blur",
          },
        ],
        agreeOn: [
          { required: true, message: "请填写付款约定", trigger: "blur" },
          {
            min: 1,
            max: 256,
            message: "长度在 1 到 256 个字符",
            trigger: "blur",
          },
        ],
        // comments: [
        //   // { required: true, message: "备注", trigger: "blur" },
        //   {
        //     min: 1,
        //     max: 256,
        //     message: "长度在 1 到 256 个字符",
        //     trigger: "blur",
        //   },
        // ],
        applyUserName: [
          { required: true, message: "请填写申请人", trigger: "blur" },
        ],
        applyDeptId: [
          { required: true, message: "请填写申请部门", trigger: "blur" },
        ],
      },
    };
  },
  //  computed: {
  //   newindirectExp: function() {
  //     let startPage = this.dialogForm.amount * this.dialogForm.indirectExpPct;

  //     return startPage;
  //   }
  // },
  watch: {
    "dialogForm.amount": function (newValue) {
      let amount = this.dialogForm.amount.replace(/,/g, "");
      this.dialogForm.indirectExp = accMul(
        amount,
        this.dialogForm.indirectExpPct / 100
      );
      this.dialogForm.indirectExp1 = (this.dialogForm.indirectExp + "").replace(
        /^\D*(\d*(?:\.\d{0,2})?).*$/g,
        "$1"
      );
      this.dialogForm.indirectExp1 = numFilter(this.dialogForm.indirectExp1);
    },

    "dialogForm.indirectExpPct": function (newValue) {
      let amount = this.dialogForm.amount.replace(/,/g, "");
      this.dialogForm.indirectExp = accMul(
        amount,
        this.dialogForm.indirectExpPct / 100
      );
      this.dialogForm.indirectExp1 = (this.dialogForm.indirectExp + "").replace(
        /^\D*(\d*(?:\.\d{0,2})?).*$/g,
        "$1"
      );
      this.dialogForm.indirectExp1 = numFilter(this.dialogForm.indirectExp1);
    },
  },
  created() {
    this.dialogForm.applyUserName = sessionStorage.getItem("name");
    this.dialogForm.applyDeptId = sessionStorage.getItem("deptId");
    this.dialogForm.applyUserId = sessionStorage.getItem("currentUserId");
    this.getContractCode(this.category);
    this.getProjectClubList(0); //获取部门一级下拉列表
    this.getapplyDeptName(); //根据部门id获取部门名称
    this.getSupplierList(); //获取供应商列表
    this.getSupplierBList(); //获取乙方供应商列表

    window.onresize = () => {
      return (() => {
        let ch1 = document.documentElement.clientHeight - 80;
        document.getElementsByClassName("AddAllContract")[0].style.height =
          ch1 + "px";
      })();
    };
  },
  mounted() {
    let ch = document.documentElement.clientHeight - 80;
    document.getElementsByClassName("AddAllContract")[0].style.height =
      ch + "px";
  },
  methods: {
    //获取路由跳转传参
    onActive() {
      this.activeName = "first";
      this.editFlag = this.tabRouteParam ? this.tabRouteParam.editFlag : false;
      this.RouteParam = this.tabRouteParam;
      if (this.editFlag) {
        //编辑 获取一条总包合同信息
        this.contractId = this.tabRouteParam.id;

        this.getContractDetail(this.contractId, false);
      } else {
        //新增追加总包合同
        let addType = this.tabRouteParam?.contractType ?? "";
        if (addType === "addMore") {
          this.dialogForm.relatedId = this.tabRouteParam.id;
          this.dialogForm.relatedSerialNumber = this.tabRouteParam.serialNumber;
          this.editcontractTypeFlag = true;
          this.getContractDetail(this.dialogForm.relatedId, true);
        }
      }
    },
    //获取部门名称
    getapplyDeptName() {
      //根据用户id去获取组织id
      let reqParam = {
        userId: this.dialogForm.applyUserId,
      };
      getOrgIdService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            this.dialogForm.applyDeptName = res.data.deptDisplayName;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //获取所有甲方供应商列表
    getSupplierList() {
      let reqParam = {
        topType: "aType", //甲方供应商
        pageIndex: 1,
        pageSize: -1,
      };
      getValidSupplierAList(reqParam)
        .then((res) => {
          if (res.code == 10000000) {
            this.SupplierList = res.data;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },

    //获取所有乙方供应商列表
    getSupplierBList() {
      let reqParam = {
        topType: "bType", //分项合同合同甲方获取乙方供应商列表
        pageIndex: 1,
        pageSize: -1,
      };
      getValidSupplierAList(reqParam)
        .then((res) => {
          if (res.code == 10000000) {
            this.SupplierBList = res.data;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },

    // 提交合同基本信息
    saveContractInfo(val) {
      //val=true 暂存 false：提交

      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.dialogForm.isTempSave = val;
          if (val) {
            this.tempSaveContent();
            return;
          }
          if (this.dialogForm.indirectExpPct > 100) {
            this.$alert("税率应该小于等于100", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          if (
            !this.approveParams.approveProcessDtoList ||
            this.approveParams.approveProcessDtoList.length < 1
          ) {
            this.$alert(" 未选择审批人员", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          for (
            let i = 0;
            i < this.approveParams.approveProcessDtoList.length;
            i++
          ) {
            delete this.approveParams.approveProcessDtoList[i].type;
            if (
              this.approveParams.approveProcessDtoList[i].approveUserId == "" ||
              null == this.approveParams.approveProcessDtoList[i].approveUserId
            ) {
              this.$alert(
                this.approveParams.approveProcessDtoList[i].jobName +
                  " 节点未选择审批人员",
                "提示",
                {
                  confirmButtonText: "确定",
                }
              );
              return;
            }
          }
          this.$confirm("您确定提交合同吗, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "info",
          })
            .then(() => {
              this.saveContent();
            })
            .catch(() => {});
        }
        //  else {
        //   this.$alert("有错误信息，请填写正确后再提交", "提示", {
        //     confirmButtonText: "确定",
        //   });
        //   return false;
        // }
      });
    },
    //提交保存合同
    saveContent() {
      this.dialogForm.amount = this.dialogForm.amount.replace(/,/g, "");
      this.dialogForm.provisionalAmount =
        this.dialogForm.provisionalAmount.replace(/,/g, "");
      let data = { ...this.dialogForm };

      if (!this.editFlag) {
        //新增总包合同
        saveContractInfoServices(data)
          .then((res) => {
            if (res.code == 10000000) {
              //保存审批流
              this.saveApproveFun(res.data);
            } else {
              if (res.code >= 20000000) {
                this.Fornmat(0);
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                this.Fornmat(0);
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定",
                });
              }
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      } else {
        //更新总包合同
        data.id = this.contractId;
        updateContractInfoServices(data)
          .then((res) => {
            if (res.code == 10000000) {
              //保存审批流
              this.saveApproveFun(this.contractId);
            } else {
              if (res.code >= 20000000) {
                this.Fornmat(0);
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                this.Fornmat(0);
                this.$alert("系统异常", "提示", {
                  confirmButtonText: "确定",
                });
              }
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },
    //暂存合同
    tempSaveContent() {
      this.dialogForm.amount = this.dialogForm.amount?.replace(/,/g, "") ?? "";
      this.dialogForm.provisionalAmount =
        this.dialogForm.provisionalAmount?.replace(/,/g, "") ?? "";
      let data = { ...this.dialogForm };

      if (!this.editFlag) {
        //新增总包合同
        saveContractInfoServices(data)
          .then((res) => {
            if (res.code == 10000000) {
              this.$message.success("暂存成功");
              this.changTabs("find-classify", "payment-cycle");
            } else {
              if (res.code >= 20000000) {
                this.Fornmat(0);
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                this.Fornmat(0);
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定",
                });
              }
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      } else {
        //更新总包合同
        data.id = this.contractId;
        updateContractInfoServices(data)
          .then((res) => {
            if (res.code == 10000000) {
              //保存审批流
              this.$message.success("更新成功");
              this.changTabs("find-report", "payment-cycle");
            } else {
              if (res.code >= 20000000) {
                this.Fornmat(0);
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                this.Fornmat(0);
                this.$alert("系统异常", "提示", {
                  confirmButtonText: "确定",
                });
              }
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },
    //创建审批流函数
    async saveApproveFun(contractId) {
      this.approveParams.itemId = contractId;
      this.approveParams.approveStatusEnum = "UNDERAPLLY"; //只是先保存，传READY；若审批流直接开始，传UNDERAPLLY
      this.approveParams.approveClass = "GENERAL_CONTRACT";
      this.approveParams.itemName = `${this.dialogForm.applyUserName}关于总包合同 ${this.dialogForm.name} 编号 ${this.dialogForm.serialNumber} 的总包合同申请`;
      let res = await saveApproveFun(this.approveParams);
      if (res && res.code == 10000000) {
        if (!this.editFlag) {
          this.$message.success("保存成功");
          this.changTabs("find-classify", "payment-cycle");
        } else {
          this.$message.success("更新成功");
          this.changTabs("find-report", "payment-cycle");
        }
      } else {
        this.$message.error(res.msg||'创建审批流异常');
      }
    },
    close() {
      let that = this;
      if (this.editFlag) {
        this.changTabs("find-report", "payment-cycle");
      } else {
        this.changTabs("find-classify", "payment-cycle");
      }
    },
    //获取一条总包合同信息
    getContractDetail(id, contractTypeFlag = false) {
      if (this.RouteParam) {
        let param = {};
        param.id = id;
        getContractDetailService(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.dialogForm = res.data;
              if (contractTypeFlag) {
                this.dialogForm.contractType = "ADDITIONAL";
                this.dialogForm.relatedId = this.tabRouteParam.id;
                this.dialogForm.relatedSerialNumber =
                  this.tabRouteParam.serialNumber;
                let index = this.tabRouteParam.serialNumber.indexOf("GLZX");
                if (
                  this.dialogForm.relatedCount &&
                  this.dialogForm.relatedCount !== 0
                ) {
                  this.dialogForm.serialNumber =
                    "Z" +
                    this.dialogForm.relatedCount +
                    "-" +
                    this.dialogForm.serialNumber.substring(index);
                } else {
                  this.dialogForm.serialNumber =
                    "Z" + "-" + this.dialogForm.serialNumber.substring(index);
                }
              }
              this.dialogForm.contractItemVOs = res.data?.contractItemVOs ?? [];
              this.dialogForm.indirectExp1 = (
                this.dialogForm.indirectExp + ""
              ).replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, "$1");
              this.Fornmat(0);
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },
    //保存工程量清单子目saveChoiceItems
    saveChoiceItems(selectItems) {
      this.dialogForm.generalContractProjectDetailsVOs = selectItems;
    },
    //存储审批流
    saveApproveLine(selectItems) {
      this.approveParams.approveProcessDtoList = selectItems;
      // this.dialogForm.contractItemVOs = selectItems;
    },
    //存储附件
    saveUpdateFile(selectItems) {
      this.dialogForm.contractItemVOs = selectItems;
    },
    //获取合同分类下拉框数据
    getContractCode(category) {
      let param = {};
      param.category = category;
      getBasicDataListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            if (category == "GENERALCONTRACTTYPE") {
              this.ContractClassList = res.data; //总包合同分类
            } else {
              this.contractCodeList = res.data; //总包合同编码
            }
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {});
    },
    //获取项目部下拉列表数据
    getProjectClubList(deptId) {
      let reqParam = {
        pid: deptId,
        orgId: sessionStorage.getItem("orgId"),
      };
      getDeptListService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            console.log("--- subDeptList", res.data);
            this.subDeptList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    ShowApplyUserDia() {
      // this.applyUserDiaVisible = false;
      this.applyUserDiaVisible = true;
    },
    closeDialog() {
      this.applyUserDiaVisible = false;
    },
    //存储申请人
    saveApplyUser(selectItems) {
      this.dialogForm.applyUserId = selectItems.applyUserId;
      this.dialogForm.applyUserName = selectItems.applyUserName;
      this.dialogForm.applyDeptId = selectItems.applyDeptId;
      this.dialogForm.applyDeptName = selectItems.applyDeptName;
      //  this.$set(this.dialogForm.applyUserName);
      this.applyUserDiaVisible = false;
    },
    //数据改变时更新数据
    handleChange(value) {
      let len = value.length;
      this.dialogForm.applyDeptId = value[len - 1];
      //  let labal = this.$refs["cascaderAddr"].currentLabels; //注意2： 获取label值
    },
    //获取合同分类名称
    ContractClassChange(val) {
      let obj = {};
      obj = this.ContractClassList.find((item) => {
        return item.label == val; //筛选出匹配数据
      });
      this.dialogForm.typeValue = obj.value;
    },
    //获取合同甲方名称名称
    ContractPartAChange(val) {
      let obj = {};
      obj = this.SupplierList.find((item) => {
        return item.id == val; //筛选出匹配数据
      });
      this.dialogForm.partyA = obj.companyName;
    },
    //获取合同乙方名称名称
    ContractPartBChange(val) {
      let obj = {};
      obj = this.SupplierBList.find((item) => {
        return item.id == val; //筛选出匹配数据
      });
      this.dialogForm.partyB = obj.companyName;
    },
    //校验税率在100以内，且只能输入数字
    checkIndirectPct(val) {
      this.dialogForm.indirectExpPct = this.dialogForm.indirectExpPct.replace(
        /^\D*(\d*(?:\.\d{0,2})?).*$/g,
        "$1"
      );
      if (this.dialogForm.indirectExpPct > 100) {
        this.$alert("税率应该小于等于100", "提示", {
          confirmButtonText: "确定",
        });
        this.dialogForm.indirectExpPct = "";
      }
    },
    //格式化金额
    checkAmount(val) {
      if (val == 1&&this.dialogForm.amount!=0) {
        //合同金额
        this.dialogForm.amount = (this.dialogForm.amount + "").replace(
          /^\D*([,\d]*(?:\.\d{0,2})?).*$/g,
          "$1"
        );
        // this.dialogForm.amount = numFilter(this.dialogForm.amount);
      } else if (val == 2) {
        //暂定金金额
        this.dialogForm.provisionalAmount = (
          this.dialogForm.provisionalAmount + ""
        ).replace(/^\D*([,\d]*(?:\.\d{0,2})?).*$/g, "$1");
        // this.dialogForm.provisionalAmount = numFilter(this.dialogForm.amount);

      }
    },
    Fornmat(val) {
      if (val == 1) {
        //合同金额
        this.dialogForm.amount =  this.dialogForm.amount==0?0:numFilter(this.dialogForm.amount);
      } else if (val == 2) {
        //暂定金金额       
        this.dialogForm.provisionalAmount = numFilter(
          this.dialogForm.provisionalAmount,2,1
        );
         if(this.dialogForm.provisionalAmount==0)
        this.dialogForm.provisionalAmount='0.00'

      } else {
        this.dialogForm.amount = numFilter(this.dialogForm.amount);
        this.dialogForm.provisionalAmount = numFilter(
          this.dialogForm.provisionalAmount,2,1
        );
        if(this.dialogForm.provisionalAmount==0)
        this.dialogForm.provisionalAmount='0.00'
      }
    },
    contractTypechange() {
      if (
        this.dialogForm.contractType === "TEMPORARY" &&
        this.dialogForm.serialNumber !== "" &&
        this.dialogForm.serialNumber.substring(0, 2) !== "L-"
      ) {
        this.dialogForm.serialNumber = "L-" + this.dialogForm.serialNumber;
      } else if (
        this.dialogForm.contractType === "ADDITIONAL" &&
        this.dialogForm.serialNumber !== "" &&
        this.dialogForm.serialNumber.substring(0, 2) === "L-"
      ) {
        this.dialogForm.serialNumber =
          this.dialogForm.serialNumber.substring(2);
      }
    },
    changTabs(closeTabName, openTableName, params) {
      this.bus.$emit("tabClose", closeTabName);
      this.bus.$emit("navMenuChange", {
        routeId: openTableName,
      });
    },
    //tab页切换
    handleTabClick(tab, event) {
      switch (this.activeName) {
        case "seven":
          break;
        case "second":
          this.$refs.engineerListAll.initList();
          break;
        default:
          // this.Contractform.tabIndex = "0";
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.AddAllContract {
  background-color: white;
  height: 100%;
  overflow: hidden;

  .tabWrap {
    height: calc(100% - 60px);
    // /deep/.el-tabs__item.is-top.is-active {
    //   background-color: #ffffff;
    // }
    /deep/ .el-tabs--top {
      height: 100%;
      overflow: hidden;

      .el-tabs__content {
        height: calc(100% - 80px);
        padding: 20px;
        overflow: auto;

        .el-form-item {
          width: 100%;
        }

        .el-checkbox {
          line-height: 40px;
        }

        .el-textarea {
          min-width: 0px !important;
        }
        .el-cascader {
          width: 100%;
        }

        .el-form-item__content {
          width: calc(100% - 110px);

          .el-input {
            width: 100%;
          }
          .el-select {
            width: 100%;
          }
        }
      }
    }
  }

  .bottomBtn {
    border-top: 1px solid #e6e6e6;
    width: 72%;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}

.el-container {
  position: relative;
  width: 100%;
  min-height: 100%;
  /*设置padding-bottom值大于等于footer的height值，以保证main的内容能够全部显示出来而不被footer遮盖；*/
  padding-bottom: 40px;
  box-sizing: border-box;
}
.btnList {
  text-align: center;
  margin-top: 20px;
}
.screenPanel {
  text-align: left;
  height: auto;
}

/deep/ .el-tabs__item {
  padding: 0 20px !important;
}
/deep/ .el-tabs__header {
  padding-right: 0px !important;
}
.firstTab {
  width: 72%;
}
.firstTab1 {
  width: 100%;
}
@media only screen and(max-width:1680px) {
  .firstTab {
    width: 90%;
  }
  .firstTab1 {
    width: 100%;
  }
}
</style>

<style scoped>
.hidden >>> .el-upload--picture-card {
  display: none;
}
</style>
